var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container container-fluid"},[_c('h1',{staticClass:"page-heading mb-0"},[_vm._v("Science Volunteer Modal")]),_vm._v(" "),_c('div',{staticClass:"PHD"},[_c('aha-component',{attrs:{"title":"Default"}},[_c('phd-science-volunteer-modal',{attrs:{"modal-data":{
                isVolunteer: true,
                yesRedirect:'http://www.heart.org',
                title: 'Science Volunteer',
                message:'Are you interested in becoming a science volunteer?',
                yesLabel: 'Yes',
                noLabel: 'No'
            }}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e9a350d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./demo/pages/components/phd-science-volunteer-modal.vue
// module id = 1592
// module chunks = 0